import React from "react";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../../../contexts/DialogContext";
import SaveIcon from "@mui/icons-material/Save";

import { Grid, DialogActions, Button, CircularProgress } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useRate from "../../../../../hooks/useRate";

function DeleteRate(props) {
  const { rateId, refreshPage } = props;

  const { deleteRate, isLoading } = useRate();
  const dispatch = useDispatch();
  const { unSetDialog } = useDialog();

  const methods = useForm();

  const { handleSubmit } = methods; // ESLint cache trigger

  const onSubmit = async () => {
    try {
      await deleteRate(rateId);
      dispatch(showSuccessSnackbar("Rate deleted successfully!"));
      refreshPage();
      unSetDialog("delete_rate");
    } catch (err) {
      const errMsg = err?.response?.data?.message || err?.message || "Failed to delete rate";
      dispatch(showErrorSnackbar(errMsg));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={6}>
              <i>Do you want to delete this ?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isLoading ? <CircularProgress size={24} /> : null}
              disabled={isLoading}
            >
              Yes
            </Button>

            <Button variant="text" onClick={() => unSetDialog("delete_rate")} color="primary">
              No
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default DeleteRate;
